import sort from '@/auth/sort'
import md5 from 'js-md5'

function sign (params) {
  let secret = 'WDID429FKS92KDK3'
  let pstr = sort(params)
  let stringSignTemp = pstr + secret
  return md5(stringSignTemp).toUpperCase()
}

export default sign



// WEBPACK FOOTER //
// ./src/auth/sign.js